/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import _ from 'lodash';
import '@culturehq/add-to-calendar/dist/styles.css';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { Container } from 'react-bootstrap';
import i18n from 'i18next';
import { reactI18nextModule, withNamespaces } from 'react-i18next';
import { errorHandler, logWarning } from '../utils/error-handler';
import { addBreadcrumb } from '../utils/sentry-config';

import Promise from 'bluebird';
import Loader from '~loader';

import * as componentActions from '~actions/component_actions';

import CheckoutLayout from './event_layouts/checkout';
import ListLayout from './event_layouts/list';
import MapLayoutContainer from './event_layouts/map';
import SideBySideLayout from './event_layouts/large-list';
import ColumnLayout from './event_layouts/column_layout';
import CalendarLayout from './event_layouts/calendar';
import Header from './header';
import Featured from './event_layouts/feature';
import NoEvents from './no_events';
import { applyFilters } from './search-filters/util';
import Filters from './search-filters';
import { LocaleWrapper } from '../locale-wrapper';
import ListCompressContainer from './event_layouts/list-compress';
import TicketSpotLogo from '../../static/ticket-spot-logo.png';

// new Layout imports
import DesktopList1 from './new-event-layouts/desktop/list1/list1';
import DesktopList2 from './new-event-layouts/desktop/list2/list2';
import DesktopList3 from './new-event-layouts/desktop/list3/list3';
import DesktopColumns from './new-event-layouts/desktop/columns/columns';
import DesktopMap from './new-event-layouts/desktop/map/map';
import DesktopCalendar from './new-event-layouts/desktop/calendar/calendar';
import DesktopCheckout from './new-event-layouts/desktop/checkout-only/checkout-only';
import DesktopMonthlyView from './new-event-layouts/desktop/monthly-view/monthly-view';

import MobileList1 from './new-event-layouts/mobile/list1';
import MobileList2 from './new-event-layouts/mobile/list2';
import MobileStack1 from './new-event-layouts/mobile/stack1';
import MobileStack2 from './new-event-layouts/mobile/stack2';
import MobileCheckoutOnly from './new-event-layouts/mobile/checkout-only';

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          'Welcome to React': 'Welcome to React and react-i18next',
        },
      },
    },
    lng: 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });

const STYLESHEET = Array.from(document.getElementsByTagName('style')).find((s) => s.hasAttribute('ticket-spot-style'));

class Widget extends Component {
  constructor() {
    super();
    this.delayedResize = _.debounce(this.resizeComponent.bind(this), 800);
    this.hasMounted = false;
    this.messageHandler = null;

    console.log('Widget constructor called');
    this.state = {
      initialHeight: 0,
      originalStyle: STYLESHEET.innerHTML,
    };
  }

  componentDidMount() {
    try {
      console.log('componentDidMount called, hasMounted:', this.hasMounted);
      console.log('Stack trace:', new Error().stack);

      if (this.hasMounted) {
        console.log('component mounted - skipped (already mounted)');
        return;
      }
      this.hasMounted = true;
      console.log('component mounted - executing initialization');
      addBreadcrumb('Widget componentDidMount started', 'lifecycle');

      const search = new URLSearchParams(window.location.search);
      window.isMobileType = search.get('deviceType') === 'mobile';
      if (/Mobi/.test(window.navigator.userAgent)) {
        // mobile!
        window.isMobileType = true;
      }

      this.initializeAnalytics();
      this.registerEventListeners();
      const design = this.props.settings.get('design');
      if (design) {
        this.applyDesign(design.toJS());
      }

      // Hack to wait for react to finish rendering before updating the iframe
      setTimeout(() => {
        try {
          this.setState({
            initialHeight: this.updateCompHeight(),
          });
        } catch (error) {
          errorHandler(error, {
            tags: { component: 'widget-main', action: 'height_update' },
            extra: { hasContainer: !!this.containerEl },
          });
        }
      }, 2000);

      addBreadcrumb('Widget componentDidMount completed', 'lifecycle');
    } catch (error) {
      errorHandler(error, {
        tags: { component: 'widget-main', action: 'component_mount' },
      });
    }
  }

  componentDidUpdate() {
    this.updateCompHeight();
  }

  componentWillUnmount() {
    console.log('componentWillUnmount - cleaning up event listeners');

    // Remove message listener
    if (this.messageHandler) {
      window.removeEventListener('message', this.messageHandler, false);
      this.messageHandler = null;
    }

    // Reset mount flag
    this.hasMounted = false;
  }

  setHeight(height) {
    window.parent.postMessage({ type: 'ticket-spot-set-height', value: height }, '*');
  }

  initializeAnalytics() {
    try {
      const { settings } = this.props;
      const googleMeasurementId = settings.get('googleMeasurementId');
      const facebookPixelId = settings.get('facebookPixelId');

      addBreadcrumb('Initializing analytics', 'analytics', 'info', {
        hasGoogle: !!googleMeasurementId,
        hasFacebook: !!facebookPixelId,
      });

      // Initialize Google Analytics
      if (googleMeasurementId) {
        try {
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${googleMeasurementId}`;
          script.onerror = () => {
            logWarning('Failed to load Google Analytics script', { googleMeasurementId });
          };
          document.head.appendChild(script);

          window.dataLayer = window.dataLayer || [];
          // eslint-disable-next-line no-inner-declarations
          function gtag() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', googleMeasurementId);
        } catch (error) {
          errorHandler(error, {
            tags: { component: 'widget-main', action: 'google_analytics_init' },
            extra: { googleMeasurementId },
          });
        }
      }

      // Initialize Facebook Pixel
      if (facebookPixelId) {
        try {
          !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            // eslint-disable-next-line func-names, no-multi-assign
            n = f.fbq = function () {
              // eslint-disable-next-line prefer-rest-params
              n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            t.onerror = () => {
              logWarning('Failed to load Facebook Pixel script', { facebookPixelId });
            };
            // eslint-disable-next-line prefer-destructuring
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', facebookPixelId);
          fbq('track', 'PageView');
        } catch (error) {
          errorHandler(error, {
            tags: { component: 'widget-main', action: 'facebook_pixel_init' },
            extra: { facebookPixelId },
          });
        }
      }
    } catch (error) {
      errorHandler(error, {
        tags: { component: 'widget-main', action: 'analytics_init' },
      });
    }
  }

  updateCompHeight = () => {
    if (this.containerEl) {
      const height = this.containerEl.clientHeight;
      this.setHeight(height);
      return height;
    }
    return 0;
  };

  resizeComponent = (force = false) => {
    if (this.containerEl && this.containerEl.clientHeight < this.state.initialHeight && !force) {
      this.setHeight(this.state.initialHeight);
    } else if (this.containerEl) {
      const height = this.containerEl.clientHeight;
      this.setState({
        initialHeight: height,
      });
      this.setHeight(height);
    }
  };

  registerEventListeners = () => {
    const { updateSettingsState, getEvents } = this.props;

    // Remove existing listener if it exists
    if (this.messageHandler) {
      console.log('Removing existing message listener before registering new one');
      window.removeEventListener('message', this.messageHandler, false);
    }

    const onMsg = (msg) => {
      console.log('Received message from dashboard iframe', msg.origin, process.env.DASHBOARD_CLIENT_URL);
      if (!process.env.DASHBOARD_CLIENT_URL.startsWith(msg.origin)) {
        return;
      }
      const { data } = msg;
      let parsedData;
      try {
        parsedData = typeof data === 'string' ? JSON.parse(data) : data;
      } catch (error) {
        console.warn('Failed to parse message data:', error);
        return;
      }

      if (parsedData.type === 'settings') {
        const { key, value, shouldFetchEvents = false, hardRefresh = false, resizeWidget = false } = parsedData;
        if (hardRefresh) {
          window.location.reload();
        }
        (shouldFetchEvents ? getEvents() : Promise.resolve()).then(() => {
          if (!_.isUndefined(key) && !_.isUndefined(value)) {
            updateSettingsState(key, value);
          }
          if (resizeWidget) {
            _.defer(this.updateCompHeight);
          }
        });
      }
      if (parsedData.type === 'design') {
        this.applyDesign(parsedData);
        _.defer(this.updateCompHeight);
      }
    };

    // Store reference for cleanup
    this.messageHandler = onMsg;
    console.log('Registering message listener');
    window.addEventListener('message', onMsg, false);
  };

  applyDesign = (data) => {
    try {
      const { originalStyle } = this.state;

      if (!originalStyle) {
        logWarning('Original style not available for design application');
        return;
      }

      const { overrides = {}, theme = {} } = data;

      addBreadcrumb('Applying design changes', 'ui', 'info', {
        hasOverrides: Object.keys(overrides).length > 0,
        hasTheme: Object.keys(theme).length > 0,
      });

      const regExp = /{{.+?}}/g;
      const matches = originalStyle.match(regExp);
      if (!matches) return;

      const getValue = (placeholders, key, mapping) => {
        const found = placeholders.find((placeholder) => key.includes(placeholder));
        if (found) return mapping[found].value;
        return null;
      };

      const overrideKeys = Object.keys(overrides);
      const themeKeys = Object.keys(theme).filter((t) => t !== 'id');
      const resolvedStyles = matches.reduce((res, cur) => {
        const overrideFound = getValue(overrideKeys, cur, overrides);
        const themeFound = getValue(themeKeys, cur, theme);
        return { ...res, [cur]: overrideFound || themeFound };
      }, {});

      const result = Object.keys(resolvedStyles).reduce((res, style) => res.replace(new RegExp(style, 'g'), resolvedStyles[style]), originalStyle);
      if (STYLESHEET && STYLESHEET.innerHTML !== undefined) {
        STYLESHEET.innerHTML = result;
        // Force browser to re-apply styles
        STYLESHEET.disabled = true;
        STYLESHEET.disabled = false;
      } else {
        logWarning('STYLESHEET element not available for design updates');
      }
    } catch (error) {
      errorHandler(error, {
        tags: { component: 'widget-main', action: 'apply_design' },
        extra: { data },
      });
    }
  };

  newLayoutComponents(settings, isMobile) {
    const layoutDesign = settings.get('layoutDesign');
    const mobileLayoutDesign = settings.get('mobileLayoutDesign');

    // If desktop layout is monthly-view, use it for mobile too since it's optimized for mobile
    let layoutKey;
    if (isMobile && layoutDesign === 'desktop-monthly-view') {
      layoutKey = layoutDesign;
    } else if (isMobile) {
      layoutKey = mobileLayoutDesign;
    } else {
      layoutKey = layoutDesign;
    }
    const componentMapping = {
      // desktop
      'desktop-list1': { component: DesktopList1 },
      'desktop-list2': { component: DesktopList2 },
      'desktop-list3': { component: DesktopList3 },
      'desktop-vertical': { component: DesktopColumns, props: { columns: 1 } },
      'desktop-two-columns': { component: DesktopColumns, props: { columns: 2 } },
      'desktop-three-columns': { component: DesktopColumns, props: { columns: 3 } },
      'desktop-map': { component: DesktopMap },
      'desktop-calendar': { component: DesktopCalendar },
      'desktop-checkout': { component: DesktopCheckout },
      'desktop-monthly-view': { component: DesktopMonthlyView },

      // mobile
      'mobile-stack1': { component: MobileStack1 },
      'mobile-stack2': { component: MobileStack2 },
      'mobile-list1': { component: MobileList1 },
      'mobile-list2': { component: MobileList2 },
      'mobile-checkout': { component: MobileCheckoutOnly },
    };
    return componentMapping[layoutKey];
  }

  layoutComponent(settings, isMobile) {
    const layoutDesign = settings.get('layoutDesign');
    // If desktop layout is monthly-view, don't use default mobile ListLayout
    if (isMobile && layoutDesign !== 'desktop-monthly-view') {
      return { component: ListLayout };
    }
    const mapping = {
      list: { component: ListLayout },
      listCompress: { component: ListCompressContainer },
      sideBySide: { component: SideBySideLayout },
      feature: { component: Featured },
      calendar: { component: CalendarLayout },
      vertical: { component: ColumnLayout, props: { columns: 1 } },
      twoColumns: { component: ColumnLayout, props: { columns: 2 } },
      threeColumns: { component: ColumnLayout, props: { columns: 3 } },
      checkout: { component: CheckoutLayout },
      map: { component: MapLayoutContainer },
    };
    return mapping[layoutDesign];
  }

  render() {
    const { events, ticketSpotEvents, settings, filterEvents, filters, loading, getTicketSpotEvents } = this.props;
    const isMobile = window.isMobileType;

    const parsedSearch = new URLSearchParams(window.location.search);
    const viewMode = parsedSearch.get('viewMode');

    // If viewMode is 'sitepage', use desktop-monthly-view layout and hide header
    const updatedSettings = viewMode === 'sitepage' ? settings.set('layoutDesign', 'desktop-monthly-view').set('showHeader', false) : settings;

    const layout = this.layoutComponent(updatedSettings, isMobile) || this.newLayoutComponents(updatedSettings, isMobile);

    if (!layout) return <span />;
    const LayoutComponent = layout.component;
    const props = layout.props || {};

    const checkoutMode = viewMode === 'checkout';

    const completeEvents = updatedSettings.get('allowSearchPastLimits') ? ticketSpotEvents : events;
    const filteredEvents = applyFilters(filters, filters.count() > 0 ? completeEvents : events);

    return (
      <div className={cn({ mobile: isMobile }, 'events-container')} ref={(containerEl) => (this.containerEl = containerEl)}>
        <Container fluid className="widget" ref={(w) => (this.widget = w)}>
          {checkoutMode ? (
            <CheckoutLayout
              {...props}
              events={events}
              settings={updatedSettings.set('multiDayDateSelector', true)}
              onResizeComponent={this.delayedResize}
            />
          ) : (
            <div>
              <LocaleWrapper>
                <Filters events={filteredEvents} settings={updatedSettings} filterEvents={filterEvents} getTicketSpotEvents={getTicketSpotEvents} />
              </LocaleWrapper>
              {updatedSettings.get('showHeader') && <Header title={updatedSettings.get('widgetTitle')} />}
              {filteredEvents.count() === 0 && !loading ? (
                <NoEvents {...this.props} />
              ) : (
                <LayoutComponent
                  {...props}
                  events={filteredEvents}
                  settings={updatedSettings}
                  isMobile={isMobile}
                  onResizeComponent={this.delayedResize}
                />
              )}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

Widget.propTypes = {
  getEvents: PropTypes.func,
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  getSettings: PropTypes.instanceOf(Map).isRequired,
  updateSettingsState: PropTypes.func,
  publish: PropTypes.func,
  deleteSettings: PropTypes.func,
  isPremium: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  events: state.component.get('events'),
  filters: state.component.get('filters'),
  settings: state.component.get('settings'),
  isPremium: state.component.getIn(['settings', 'isPremium']),
  user: state.component.get('user'),
  loading: state.component.get('loading'),
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(componentActions, dispatch);
}

function WidgetContainer(props) {
  const prom = Promise.resolve([props.getSettings, props.getEvents]);
  console.log('WidgetContainer render called');
  const fetchData = () => prom.mapSeries((asyncMethodPassed) => asyncMethodPassed());
  return (
    <>
      <Loader key="widget" fetchData={fetchData} loadingText="Loading Events" useGlobalStateLoader>
        <>
          <Widget {...props} />
          {props?.settings && ['starter', 'trial', 'free'].includes(props.settings.get('plan')) && (
            <div className="ticket-spot-powered-by">
              <a href="https://ticketspot.io" target="_blank" rel="noreferrer">
                <span className="ticket-spot-powered-by-text">Event Success Simplified</span>
                <img src={TicketSpotLogo} alt="Powered by Ticket Spot" />
              </a>
            </div>
          )}
        </>
      </Loader>
    </>
  );
}

WidgetContainer.propTypes = {
  getSettings: PropTypes.instanceOf(Map).isRequired,
  getEvents: PropTypes.instanceOf(Map).isRequired,
  filterEvents: PropTypes.instanceOf(Map).isRequired,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(WidgetContainer));
